import axiosInstance from "../config/axiosInterceptor";

export async function getAggregation(widgetBody, url, nodeId = null) {
  const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
  const fullUrl = nodeId ? `${normalizedUrl}/${nodeId}` : normalizedUrl;
  return await axiosInstance.post(fullUrl, widgetBody);
}


